import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'travel-ui-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.scss']
})
export class RatingsComponent implements OnInit {

  /** Rating to be shown */
  @Input() set setRating(rating: any) {
    this.setRatingStars(rating);
  }

  /** Maximum allowed stars */
  MAX_RATING = 5;

  /** Class name for active star */
  ACTIVE_STAR_ICON = 'active-star';

  /** class name for inactive star */
  INACTIVE_STAR_ICON = 'inactive-star';

  /** Contains sequence of stars to be shown */
  ratingStars: any;

  constructor() { }

  ngOnInit() {
  }

  /** Sets star rating classes according to the given rating */
  setRatingStars(rating: any) {
    rating = rating > this.MAX_RATING ? this.MAX_RATING : rating;
    this.ratingStars = [];

    for (let i = 0; i < Math.floor(rating); i++) {
      this.ratingStars.push(this.ACTIVE_STAR_ICON);
    }
    // for (let i = this.ratingStars.length; i < this.MAX_RATING; i++) {
    //   this.ratingStars.push(this.INACTIVE_STAR_ICON);
    // }

  }

}
